// extracted by mini-css-extract-plugin
export default {"appWrapper":"PageLayout_appWrapper__LXy+Q","app":"PageLayout_app__WHLhU","wrapper":"PageLayout_wrapper__MrHa5"};